import { LoadingListEntityProfile, ProfileGrant } from "Admin/Components";
import { getProfileGrants } from "Admin/Service/Profile";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { Empty } from "antd";
import { useEffect, useState } from "react";
import styles from "./Grants.module.scss";
const Grants = () => {
  const [data, setData] = useState({
    data: [],
    isLoading: true,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  useEffect(() => {
    setData({ data: [], isLoading: true });
    getProfileGrants(pagination.page - 1, pagination.rowsPerPage, (res) => {
      handleAPIResponse(res, () => {
        setData({
          data: res.data.grants,
          isLoading: false,
        });
        if (res.data.total) {
          setPagination({
            ...pagination,
            totalRows: res.data.total,
          });
        }
      });
    });
  }, []);

  return (
    <div className={styles["grants"]}>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data.length > 0 ? (
            data?.data.map((item, index) => {
              return <ProfileGrant award={item} key={index} />;
            })
          ) : (
            <Empty description="No Award Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={false}
      />
    </div>
  );
};

export default Grants;
